import scrollableSection from "../components/scrollableSection"
const Home = () =>{
    // Need to pass ( if has slider in Mobile, and left section count of entire sections and Right section count of entire sections)
    scrollableSection(true,3,3);
}

export default Home